import { useIsNewNavigation } from "../../../api/hooks/defs/navigation";
import { useFeatureFlagQuery } from "../../../hooks/useFeatureFlag";

export const ENHANCED_AI_PANEL_FEATURE_FLAG = "ff-temp-is-enhanced-conversational-ai-panel-enabled";

/** Whether the enhanced AI side panel is active: ephemeral FF + new side nav. Legacy nav keeps the bubble. */
export const useEnhancedAiPanelEnabled = (): boolean => {
	const { value: enhancedAiPanelFlagEnabled } = useFeatureFlagQuery(ENHANCED_AI_PANEL_FEATURE_FLAG, false);
	const isNewNavigation = useIsNewNavigation();

	return enhancedAiPanelFlagEnabled && isNewNavigation;
};
